// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"178":"33c9bb14","402":"af17fab0","516":"35a8c82c","766":"b46f24ae","787":"11545646"}[chunkId] + ".chunk.css";
};